// extracted by mini-css-extract-plugin
export default {"Cosultant":"Cosultant_Cosultant__kT4uH","overlay":"Cosultant_overlay__sNnw6","content":"Cosultant_content__wuEcJ","image":"Cosultant_image__CsdYr"};